export const MODES = {
  LOG_IN: 'LOG_IN',
  SIGN_UP: 'SIGN_UP',
  RESET_PIN: 'RESET_PIN',
};
